export var appList = [
    {
        title: "INSIGHTS",
        owner: "GIFSQuantSupport@vanguard.com",
        link: "https://figinsights.web.vanguard.com/",
        tags: "insights,rv,credit,muni,rates,relative,value,mbs,popto",
        text: "The Fig Insights Data and Analytics platform offering a suite of RV tools, including Credit, Muni, Rates, and MBS"
        },
    {
        title: "Data Explorer",
        link: "https://gdv-cdas-web-internal.ecs.us-east-1.fineisp.c1.vanguard.com/",
        owner: "Teams Channel: Data Explorer Support",
        tags: "dataexplorer,data,athena,lake,gidm",
        text: "Data Explorer provides a simple interface to discover and explore data available in the data lake and jumpstarts analytics by getting you to your data in enterprise tools such as Athena, Python and Jupyter Notebook."
    },
    {
        title: "New Issue Allocation",
        link: "https://nia-newissueallocationwebapp-internal.ecs.us-east-1.invfigp.c1.vanguard.com/home/US",
        owner: "FIG_Execution_Automation_Team@vanguard.com",
        tags: "new,issue,allocation,muni",
        text: "Benchmark sizing tool for USD and CAD Corporate Credit used by GBI and the Active IG Desk"
    },
    {
        title: "ARMOR",
        link: "https://apii.ecs.us-east-1.gisp.c1.vanguard.com/gm3-armor-webapp/home",
        owner: "CANVIS_Developers@vanguard.com",
        tags: "armor, structured, products",
        text: "Enables user to monitor duration (across buckets and currencies) and lets user to hedge duration risk for multiple portfolios at a time"
    },
    {
        title: "CANVIS",
        link: "https://prdimgvts.vanguard.com/Citrix/PRDIMGVTSWeb/",
        owner: "CANVIS_Developers@vanguard.com",
        tags: "canvis,basket,etf",
        text: "THE FIG ETF application to create baskets for daily publication and create/redeem transactions."
    },
    {
        title: "SPARC",
        link: "https://apii.ecs.us-east-1.gisp.c1.vanguard.com/gm3-structuredproducts-webapp/grid-dashboard",
        owner: "CANVIS_Developers@vanguard.com",
        tags: "sparc,structured,products,abs,cmbs",
        text: "Portfolio monitoring and Allocation tool for Structured Products desk"
    },
    {
        title: "Fixed Income Trade Review",
        link: "https://ts0-tradesignoff-ui-internal.ecs.us-east-1.invfigp.c1.vanguard.com/home",
        owner: "FIG_Execution_Automation_Team@vanguard.com",
        tags: "fixed-income,trade,review,pm,portfolio,manager,signoff",
        text: "End of day supervisor signoff of trading activity used by all of FIG. "
    },
    {
        title: "MuniVision",
        link: "https://mw3-muni-workflow-ui-internal.ecs.us-east-1.invfigp.c1.vanguard.com/home",
        owner: "FIG_Execution_Automation_Team@vanguard.com",
        tags: "munivision,muni",
        text: "Muni Credit Research Primary Market tool used for deal notes and ongoing monitoring of Credits."
    },
    {
        title: "MarLi",
        link: "https://pt0-gis-marli-aggregator-internal.ecs.us-east-1.invfigp.c1.vanguard.com/",
        owner: "FIG_Execution_Automation_Team@vanguard.com",
        tags: "marli",
        text: "Liquidity Aggregation UI showing dealer inventory paired with Credit RV attribution"
    },
    {
        title: "CreditScope",
        link: "https://vanguard.invtoolshosting.com/",
        owner: "CANVIS_Developers@vanguard.com",
        tags: "creditscope",
        text: ""
    },
    {
        title: "ICAP",
        link: "https://icap.vanguard.com/",
        owner: "Intraday fund cashflow data",
        tags: "alfa,portfolio,ICAP,fund,muni,credit,cashflow,icap",
        text: "Pre-trade List Tool to show which dealers are best positioned to provide liquidity and levels."
    },
    {
        title: "Optimizer",
        link: "https://fig-optimizer.invfigp.c1.vanguard.com/dashboard",
        owner: "GIFS_FIG_Optimizer_Support@vanguard.com",
        tags: "optimizer,etf,fund,opto",
        text: "Optimizer for ETFs and funds."
    },
];
